var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo28 = function SvgInfo28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.834 9.332a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0Zm0 3.5a1.167 1.167 0 0 1 2.333 0v5.833a1.167 1.167 0 0 1-2.333 0v-5.833Zm1.167 10.5c-5.147 0-9.334-4.187-9.334-9.333s4.187-9.334 9.334-9.334c5.146 0 9.333 4.188 9.333 9.334s-4.187 9.333-9.333 9.333Zm0-21c-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666 6.442 0 11.666-5.223 11.666-11.666 0-6.444-5.224-11.667-11.666-11.667Z",
    fill: "#008545"
  })));
};
export default SvgInfo28;